import React from 'react';
import { List } from 'antd';
import { Section } from './section/index';

const TemplateEditor = ({ scheme }) => {
  const parsedScheme = React.useMemo(() => {
    if (!scheme) return [];
    try {
      const parsed = JSON.parse(scheme);
      return parsed;
    } catch (e) {
      return [];
    }
  }, [scheme]);

  return (
    <List
      dataSource={parsedScheme}
      split={false}
      renderItem={(section, index) => {
        return <Section section={section} ordinal={index + 1} />;
      }}
    />
  );
};

export default TemplateEditor;
